export { default as PbTips } from './component';
